import { useCallback, useEffect, useState } from 'react';
import {
  getReplyActivity,
  sendReplyDraftHeartbeat,
  clearReplyDraft
} from 'src/utils/MailOrbitService';

// Sunucu presence'ı 45 sn sonra düşürür; 15 sn'lik heartbeat bir iki kaçırmaya dayanır.
export const REPLY_ACTIVITY_INTERVAL_MS = 15000;

/**
 * Eşzamanlı cevap uyarısı: başkasının taslak/cevap durumunu yoklar; `drafting` iken kendi
 * "cevap yazıyorum" heartbeat'ini gönderir. Tüm hatalar yutulur (yumuşak ipucu; cevaplamayı engellemez).
 */
const useReplyActivity = ({ conversationId, enabled, drafting }) => {
  const [activity, setActivity] = useState(null);

  const refresh = useCallback(async () => {
    if (!enabled) return null;
    try {
      const latest = await getReplyActivity(conversationId);
      setActivity(latest);
      return latest;
    } catch (e) {
      return null;
    }
  }, [enabled, conversationId]);

  useEffect(() => {
    if (!enabled) return undefined;
    const initial = setTimeout(refresh, 0);
    const timer = setInterval(refresh, REPLY_ACTIVITY_INTERVAL_MS);
    return () => {
      clearTimeout(initial);
      clearInterval(timer);
    };
  }, [enabled, refresh]);

  useEffect(() => {
    if (!enabled || !drafting) return undefined;
    const beat = () => {
      sendReplyDraftHeartbeat(conversationId).catch(() => {});
    };
    beat();
    const timer = setInterval(beat, REPLY_ACTIVITY_INTERVAL_MS);
    return () => {
      clearInterval(timer);
      clearReplyDraft(conversationId).catch(() => {});
    };
  }, [enabled, drafting, conversationId]);

  return { activity, refresh };
};

export default useReplyActivity;
